export const modalBodyWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  width: '100%',
};

export const modalStatusRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  py: 1,
};

export const modalSectionLabelStyles = {
  textTransform: 'uppercase',
  letterSpacing: 0.4,
};

export const watchOutWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 1.5,
  borderRadius: 1,
  bgcolor: 'warning.light',
};

export const inlineCodeStyles = {
  fontFamily: 'monospace',
  fontSize: '0.875em',
  px: 0.5,
  py: 0.125,
  mx: 0.25,
  borderRadius: 0.5,
  bgcolor: 'grey.100',
  color: 'text.primary',
};

export const markdownParagraphStyles = {
  m: 0,
  '&:not(:last-of-type)': {
    mb: 1,
  },
};

export const markdownListStyles = {
  listStyleType: 'disc',
  pl: 3,
  m: 0,
  '& > li': {
    mb: 0.5,
  },
  '& > li:last-of-type': {
    mb: 0,
  },
  '&:not(:last-child)': {
    mb: 1,
  },
};
